import { useState, useEffect } from "react";

export const useRuleEdit = ({
  rule,
  createRule,
  updateRule,
  cancelEditing,
  close,
}) => {
  const [title, setTitle] = useState(rule?.title);
  const [subjectFilters, setSubjectFilters] = useState({});
  const [pageFilters, setPageFilters] = useState({});
  const [factFilters, setFactFilters] = useState({});
  const [condition, setCondition] = useState('');

  useEffect(() => {
    console.log('pre', rule)
    if (rule) {
      setTitle(rule.title || "");
      setSubjectFilters(rule.subjectFilters || {});
      setPageFilters(rule.pageFilters || {});
      setFactFilters(rule.factFilters || {});
      setCondition(rule.condition || '');
    }
  }, [rule]); 

  const onReset = () => {
    setSubjectFilters(rule.subjectFilters || {})
    setPageFilters(rule.pageFilters || {})
    setFactFilters(rule.factFilters || {})
    setCondition(rule.condition || '')
  };

  const create = () => {
    if (!rule.id) {
      createRule({
        id: rule.id,
        title,
        subjectFilters,
        pageFilters,
        factFilters,
        condition
      });
    } else {
      updateRule(rule.id, {
        ...rule,
        title,
        subjectFilters,
        pageFilters,
        factFilters,
        condition
      });
    }
  };

  const cancel = () => {
    if (rule?.id) {
      onReset();
      cancelEditing();
      return;
    }
    close();
  };
  return {
    save: create,
    cancel: cancel,
    id: rule?.id,
    title: {
      value: title,
      update: (value) => setTitle(value.target.value),
    },
    subjectFilters: {
      value: subjectFilters,
      update: (value) => setSubjectFilters(value),
    },
    pageFilters: {
      value: pageFilters,
      update: (value) => setPageFilters(value),
    },
    factFilters: {
      value: factFilters,
      update: (value) => setFactFilters(value),
    },
    condition: {
      value: condition,
      change: (value) => setCondition(value),
    }
  };
};
